/**
 * Converts timespan strings to number of seconds, and is quite liberal about
 * accepted values. Returns null if input is empty or invalid. Examples:
 *
 * `"59" => 59`
 *
 * `"0.123" => 0.123`
 *
 * `"1:59" => 119`
 *
 * `"1:99" => 159`
 *
 * `"1:00:00" => 3600`
 *
 * `"1:00:00:00" => null`
 *
 * @param time string to convert to a number
 */

export function parseTime(time: string | number | null | undefined): number | null {
  const timeStringGuard = time?.toString().replaceAll(/[^\d:,.]+/g, "");
  const timeString = timeStringGuard?.toString().replace(/,/g, ".");

  if (timeString == null || timeString === "") {
    return null;
  }
  if (!/^[0-9.,:]*$/.test(timeString)) {
    return null;
  }
  const sections = timeString.split(":");
  if (sections.length > 3) {
    return null;
  }
  let seconds = 0;
  let factor = 1;
  for (let i = sections.length - 1; i >= 0; i -= 1) {
    const toAdd = Number.parseFloat(sections[i] ?? "0") * factor;
    seconds += Number.isNaN(toAdd) ? 0 : toAdd;
    factor *= 60;
  }
  return seconds;
}
